import React, { useState, useEffect } from "react";
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { NavLink, useLocation } from "react-router-dom";
import "../../Asserts/style/style.css"
import "./sidebar.css"
import { RxHamburgerMenu } from "react-icons/rx";
import { BsSignpost } from "react-icons/bs";
import { PiUserListLight } from "react-icons/pi";
import { GiTeamUpgrade } from "react-icons/gi";
import { FaUserSecret } from "react-icons/fa6";
import { RxDashboard } from "react-icons/rx";
const SideBar = () => {
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    // master
    const handleToggle = () => {
        setCollapsed(!collapsed);
    };
    return (
        <div>
            <ProSidebar collapsed={collapsed}>
                {collapsed ? (
                    <a href="/Integration" className="navbar-brand start">
                        <span className="logoName" style={{ marginLeft: "5px" }}>
                            Epic
                        </span>
                    </a>
                ) : (
                    <a href="/Integration" className="navbar-brand start">
                        <span className="logoName" style={{ marginLeft: "8px" }}>
                            Epic Game
                        </span>
                    </a>
                )}
                <Menu className="mt-2">
                    <MenuItem
                        icon={<RxDashboard  size={21} />}
                        active={location.pathname.startsWith('/dashboard')}
                    >
                        <NavLink to="/dashboard">
                            <div>Dashboard</div>
                        </NavLink>
                    </MenuItem>
                    <MenuItem
                        icon={<PiUserListLight  size={21} />}
                        active={location.pathname.startsWith('/UserList')}
                    >
                        <NavLink to="/UserList">
                            <div>Member List</div>
                        </NavLink>
                    </MenuItem>
                    <MenuItem
                        icon={<GiTeamUpgrade size={21} />}
                        active={location.pathname.startsWith('/UserGrade')}
                    >
                        <NavLink to="/UserGrade">
                            <div>Member Grade</div>
                        </NavLink>
                    </MenuItem>
                    <MenuItem
                        icon={<FaUserSecret  size={21} />}
                        active={location.pathname.startsWith('/UserMaster')}
                    >
                        <NavLink to="/UserMaster">
                            <div>User Master</div>
                        </NavLink>
                    </MenuItem>
                </Menu>
                <div
                    onClick={handleToggle}
                    className="sidebar-toggle-btn"
                    style={{ left: collapsed ? '100px' : '300px' }}
                >
                    <RxHamburgerMenu size={24} />
                </div>
            </ProSidebar>
        </div>
    );
};

export default SideBar;

